import React from 'react';

import { Mode } from '../types';
import { EntitiesAndAccounts } from '../useEntitiesAndAccounts';
import { CustomRolePlatformLevelPermissions } from '~/typings/API';

import { AdditionalPermissions } from './AdditionalPermissions';
import { TransfersAndAccounts } from './TransfersAndAccounts';

export enum PermissionConfigurationSection {
  All = 'Permissions',
  Transfers = 'Transfers & Accounts',
  Additional = 'Additional Permissions',
}

interface Props {
  excludeKeys?: (keyof CustomRolePlatformLevelPermissions)[];
  fieldPathPrefix?: string;
  forcedMode?: Mode;
  includeAdditionalPermissionKeys?: (keyof CustomRolePlatformLevelPermissions)[];
  liveEntitiesAndAccounts: EntitiesAndAccounts;
  onOffEnabledPermissionLevel?: 'read' | 'write';
  sandboxEntitiesAndAccounts: EntitiesAndAccounts;
  visibleSection: PermissionConfigurationSection | string;
}

export const PermissionConfiguration: React.FC<Props> = ({
  excludeKeys,
  fieldPathPrefix,
  forcedMode,
  includeAdditionalPermissionKeys,
  liveEntitiesAndAccounts,
  onOffEnabledPermissionLevel,
  sandboxEntitiesAndAccounts,
  visibleSection,
}) => (
  <>
    {(visibleSection === PermissionConfigurationSection.All ||
      visibleSection === PermissionConfigurationSection.Transfers) && (
      <TransfersAndAccounts
        excludeKeys={excludeKeys}
        fieldPathPrefix={fieldPathPrefix}
        forcedMode={forcedMode}
        sandboxEntitiesAndAccounts={sandboxEntitiesAndAccounts}
        liveEntitiesAndAccounts={liveEntitiesAndAccounts}
      />
    )}
    {(visibleSection === PermissionConfigurationSection.All ||
      visibleSection === PermissionConfigurationSection.Additional) && (
      <AdditionalPermissions
        excludeKeys={excludeKeys}
        fieldPathPrefix={fieldPathPrefix}
        includeKeys={includeAdditionalPermissionKeys}
        onOffEnabledPermissionLevel={onOffEnabledPermissionLevel}
      />
    )}
  </>
);

export default PermissionConfiguration;
